import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Alert.scss';
import {
	Info,
	Warning,
	Close,
	Success,
	Error,
	ArrowDownIcon,
	ArrowUpIcon,
} from '../../assets/icons/index';
import useTheme from '../../hooks/useTheme';
import Label from '../label/Label';


const Alert = ({
	type,
	onPrimaryAction,
	onSecondaryAction,
	title,
	message,
	primaryButton,
	secondaryButton,
	onCloseAction,
	isPrimaryClicked = false,
	showDetails = false,
	details = [],
	centerInParent = false,
	detailMessage = "",
	detailType = ""
}) => {
	const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);

	const handlePrimaryAction = () => {
		onPrimaryAction();
	};

	const handleSecondaryAction = () => {
		onSecondaryAction();
	};
	const handleCloseAction = () => {
		onCloseAction();
	};

	const toggleDetails = () => {
		setIsDetailsExpanded(!isDetailsExpanded);
	};

	const { color, FontFace, elevation } = useTheme('LIGHT');

	return (
		<div
			className="Alert"
			style={{
				boxShadow: elevation.shadow4,
				borderTop:
					type === 'info'
						? `4px solid ${color.alert.text_violet}`
						: type === 'warning'
							? `4px solid ${color.alert.text_warning}`
							: type === 'success'
								? `4px solid ${color.alert.text_success}`
								: `4px solid ${color.alert.text_error}`,
				backgroundColor: color.background.primary,
				position: centerInParent ? 'absolute' : 'fixed',
			}}
		>
			<div>
				<div className="flex flex-between">
					<div className="flex">
						{type === 'info' ? (
							<Info className="mr-15" />
						) : type === 'warning' ? (
							<Warning className="mr-15" />
						) : type === 'success' ? (
							<Success className="mr-15" />
						) : type === 'error' ? (
							<Error className="mr-15" />
						) : null}
						<span
							style={{
								color:
									type === 'info'
										? color.alert.text_violet
										: type === 'warning'
											? color.alert.text_warning
											: type === 'success'
												? color.alert.text_success
												: color.alert.text_error,
								fontSize: FontFace.font_size.small,
								fontWeight: FontFace.font_weight.bold,
							}}
						>
							{title}
						</span>
					</div>
					<div>
						<Close
							style={{ cursor: 'pointer' }}
							onClick={handleCloseAction}
						/>
					</div>
				</div>
				<p
					className="ml-40"
					style={{ fontSize: FontFace.font_size.x_small }}
				>
					{message}
				</p>
			</div>
			{showDetails && details && details.length > 0 && (
				<div
					style={{
						marginTop: '12px',
						paddingTop: '12px',
						borderTop: `1px solid ${color.separator.tertiary}`,
					}}
				>
					<a
						onClick={toggleDetails}
						style={{
							display: 'flex',
							alignItems: 'center',
							cursor: 'pointer',
							color: color.text.secondary,

							fontSize: FontFace.font_size.x_small,
							textDecoration: 'none',
						}}
					>
						{isDetailsExpanded ? (
							<>
								<ArrowUpIcon
									style={{ width: '16px', height: '16px', marginRight: '4px'  }}
								/>

								<span >
									Hide Details
								</span>
							</>
						) : (
							<>
								<ArrowDownIcon
									style={{ width: '16px', height: '16px', marginRight: '4px'  }}
								/>

								<span >
									Show Details
								</span>
							</>
						)}
					</a>

					{isDetailsExpanded && (
						<div
							style={{
								marginTop: '12px',
								padding: '12px',
								border: 'solid 1px #d9d9d9',
							}}
						>
							
								{detailMessage ?
									<Label
										type={'primary'}
										fontFamily={'Inter-SemiBold'}
										fontSize={'x_small'}
										label={detailMessage}
										style={{ cursor: 'pointer' }}
									/>
									: <p
									style={{
										fontSize: FontFace.font_size.x_small,
										fontWeight: FontFace.font_weight.bold,
										marginBottom: '7px',
									}}> Validation failed for the following entries:
									 </p>}
							
							{detailType === 'SingleLine' ? <ul> <Label
										type={'primary'}
										fontFamily={'Inter-Regular'}
										fontSize={'x_small'}
										label={details}
										style={{ cursor: 'pointer' }}
									/> </ul>: <ul
								style={{
									listStyle: 'none',
									padding: 0,
									margin: 0,
									maxHeight: details.length > 4 ? '120px' : 'auto',
									overflowY: details.length > 4 ? 'auto' : 'visible',
								}}
							>
								{details?.map((detail, index) => (
									<li
										key={index}
										style={{
											display: 'flex',
											alignItems: 'flex-start',
											marginBottom: '8px',
											fontSize:
												FontFace.font_size.x_small,
										}}
									>
										<span
											style={{
												color: color.icon.error,
												marginRight: '8px',
												fontSize: '16px',
											}}
										>
											✕
										</span>
										<span>{detail}</span>
									</li>
								))}
							</ul>}
						</div>
					)}
				</div>
			)}

			{type === 'info' || type === 'warning' || type === 'error' ? (
				<div
					className="Alert__actions"
					style={{
						borderTop:
							showDetails && details && details.length > 0
								? 'none'
								: `1px solid ${color.separator.tertiary}`,
						paddingTop: '12px',
						fontSize: FontFace.font_size.small,
						fontWeight: FontFace.font_weight.medium,
					}}
				>
					{secondaryButton && (
						<a
							className="Alert__action"
							onClick={handleSecondaryAction}
						>
							{secondaryButton}
						</a>
					)}
					{primaryButton && (
						<a
							style={{
								color:
									type === 'info'
										? color.alert.text_violet
										: type === 'warning'
											? color.alert.text_warning
											: type === 'success'
												? color.alert.text_success
												: color.alert.text_error,
								border:
									type === 'info'
										? `2px solid ${color.alert.text_violet}`
										: type === 'warning'
											? `2px solid ${color.alert.text_warning}`
											: type === 'success'
												? `2px solid ${color.alert.text_success}`
												: `2px solid ${color.alert.text_error}`,
								opacity: isPrimaryClicked ? 0.6 : 1,
								cursor: isPrimaryClicked ? 'not-allowed' : 'pointer',
								paddingLeft: '4px',
								paddingRight: '4px',
							}}
							className="Alert__action Alert__action--primary"
							onClick={
								isPrimaryClicked
									? undefined
									: handlePrimaryAction
							}
						>
							{primaryButton}
						</a>
					)}
				</div>
			) : null}
		</div>
	);
};

Alert.propTypes = {
	type: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
	onPrimaryAction: PropTypes.func,
	onSecondaryAction: PropTypes.func,
	title: PropTypes.string,
	message: PropTypes.string,
	primaryButton: PropTypes.string,
	secondaryButton: PropTypes.string,
	onCloseAction: PropTypes.func,
	isPrimaryClicked: PropTypes.bool,
	showDetails: PropTypes.bool,
	details: PropTypes.arrayOf(PropTypes.string),
	centerInParent: PropTypes.bool,
	detailMessage: PropTypes.string,
	detailType: PropTypes.string
};

Alert.defaultProps = {
	type: 'info',
	onPrimaryAction: () => { },
	onSecondaryAction: () => { },
	onCloseAction: () => { },
	title: '',
	message: '',
	primaryButton: '',
	secondaryButton: '',
	showDetails: false,
	details: [],
	detailMessage: '',
	detailType: ''
};

export default Alert;
